import React from "react";
import { connect } from "react-redux";
import { SetDepositOldBankSixNumberStatus } from '$Deposits/store/actions/DepositAction'


class MoneyInput extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };

    }

    componentDidUpdate(prevProps, prevState) {

    }
    componentDidMount() {

    }
    componentWillUnmount() {

    }

    render() {

        const {
            SetDepositOldBankSixNumberStatus,
            DepositOldBankSixNumberStatus,
            OldBankSixNumber,
        } = this.props;
        const { numCode, codeErrMsg } = DepositOldBankSixNumberStatus || {}


        return (
            <>
                <OldBankSixNumber
                    title={'Tài Khoản FUN88 (6 chữ số cuối)'} //請輸入舊收款帳號的後6碼
                    stateVal={codeErrMsg}
                    value={numCode}
                    placeholder={'Vui lòng nhập số'} //請輸入舊收款帳號的後6碼
                    onChange={(value) => { SetDepositOldBankSixNumberStatus(value) }}
                    maxLength={6}
                    keyboardType={'number-pad'}
                />

            </>
        );
    }
}

const mapStateToProps = state => ({
    DepositOldBankSixNumberStatus: state.DepositOldBankSixNumberStatus,
});
const mapDispatchToProps = {
    SetDepositOldBankSixNumberStatus: (money, methodsDetails) => SetDepositOldBankSixNumberStatus(money, methodsDetails),
};
export default connect(mapStateToProps, mapDispatchToProps)(MoneyInput);


